import { useEffect, useState } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

import copiedIcon from '../imgs/check-mark.png'
import copyIcon from '../imgs/copy-icon.png'

interface CopyTextButtonProps {
  value: string
  tooltipText: string
  className?: string
}

export const CopyTextButton = ({ value, tooltipText, className = '' }: CopyTextButtonProps) => {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    setIsCopied(false)
  }, [value])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setIsCopied(true)

      // Hide tooltip after 2.5 seconds, then reset copied state
      setTimeout(() => {
        setIsCopied(() => false)
      }, 2500)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <Tooltip open={isCopied} delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          type='button'
          onClick={handleCopy}
          className={cn(
            'flex size-9 shrink-0 cursor-pointer items-center justify-center rounded transition-opacity hover:opacity-80',
            className
          )}
        >
          {isCopied ? <img src={copiedIcon} alt='Copied' className='size-5' /> : <img src={copyIcon} alt='Copy' className='size-5' />}
        </button>
      </TooltipTrigger>
      {isCopied && <TooltipContent side='top'>{tooltipText}</TooltipContent>}
    </Tooltip>
  )
}
